function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pin-close",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_252",
  "data-name": "Rectangle 252",
  width: 48,
  height: 48,
  transform: "translate(-1 -2)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_255",
  "data-name": "Rectangle 255",
  transform: "translate(-1 25)",
  fill: "#ffad22",
  stroke: "#414143",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 18,
  rx: 9,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.6,
  y: 0.6,
  width: 46.8,
  height: 16.8,
  rx: 8.4,
  fill: "none"
})), /*#__PURE__*/React.createElement("text", {
  id: "Title",
  transform: "translate(6 26)",
  fill: "#414143",
  fontSize: 11,
  fontFamily: "PingFangTC-Semibold, PingFang TC",
  fontWeight: 600
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 12
}, "\u5FEB\u5230\u671F")), /*#__PURE__*/React.createElement("path", {
  id: "Path_2440",
  "data-name": "Path 2440",
  d: "M27.734,25.958a9.063,9.063,0,0,0,3.923-5.979,8.936,8.936,0,0,0,.112-1.412c0-6.38-6.757-11.553-15.092-11.553S1.586,12.187,1.586,18.567a8.895,8.895,0,0,0,4.662,7.844c2.2,1.262,5.558,2.435,10.842,2.435,5.458,0,8.332-1.305,10.644-2.888",
  transform: "translate(6.224 -2)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2441",
  "data-name": "Path 2441",
  d: "M16.677,7.014c8.335,0,15.092,5.173,15.092,11.553a8.936,8.936,0,0,1-.112,1.412,9.07,9.07,0,0,1-3.923,5.979c-2.313,1.583-5.186,2.888-10.644,2.888-5.285,0-8.637-1.173-10.842-2.435a8.893,8.893,0,0,1-4.663-7.844c0-6.38,6.757-11.553,15.092-11.553m0-1.2C7.694,5.814.385,11.535.385,18.567a10.256,10.256,0,0,0,.724,3.774,10.363,10.363,0,0,0,4.543,5.111A22.882,22.882,0,0,0,17.09,30.046c5.989,0,9.084-1.566,11.321-3.1a10.3,10.3,0,0,0,4.431-6.78,10.206,10.206,0,0,0,.127-1.6c0-7.032-7.309-12.753-16.292-12.753",
  transform: "translate(6.224 -2)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2442",
  "data-name": "Path 2442",
  d: "M17.84,14.608c4.859.363,8.855.525,11.554.6a15.131,15.131,0,0,1,1.922.548,10.9,10.9,0,0,0-3.184-4.7c-1.475,0-2.611.1-2.611.1A85.881,85.881,0,0,1,8.013,11.2s-1.26-.114-2.849-.1A10.836,10.836,0,0,0,2,15.878c.419-.16.869-.314,1.351-.449C4.575,15.4,6.157,15.3,8.2,15.08c0,0,7.186-.656,9.643-.472",
  transform: "translate(6.224 -2)",
  fill: "#dfdfdf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2443",
  "data-name": "Path 2443",
  d: "M15.8,9.928a.349.349,0,0,1-.209-.062.182.182,0,0,1-.086-.151V5.639a.182.182,0,0,1,.086-.151.349.349,0,0,1,.209-.062h1.894a5.948,5.948,0,0,1,.979.074,3.038,3.038,0,0,1,.791.239,1.326,1.326,0,0,1,.55.458,1.306,1.306,0,0,1,0,1.386,1.476,1.476,0,0,1-.546.484,2.931,2.931,0,0,1-.782.275,4.648,4.648,0,0,1-.947.091h-.689c-.027,0-.041.01-.041.03V9.715a.185.185,0,0,1-.082.151.333.333,0,0,1-.2.062ZM17,7.553c0,.02.014.03.041.03h.615q1.082,0,1.082-.692a.483.483,0,0,0-.279-.469,1.964,1.964,0,0,0-.844-.139h-.574c-.027,0-.041.008-.041.023Z",
  transform: "translate(6.224 -2)",
  fill: "#07df80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2444",
  "data-name": "Path 2444",
  d: "M13.244,21.209h-.509a.344.344,0,0,1-.344-.343V18.911a.343.343,0,0,1,.344-.343h.509a.342.342,0,0,1,.343.343v1.955a.343.343,0,0,1-.343.343",
  transform: "translate(6.224 -2)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2445",
  "data-name": "Path 2445",
  d: "M21.258,21.209h-.509a.344.344,0,0,1-.344-.343V18.911a.343.343,0,0,1,.344-.343h.509a.342.342,0,0,1,.343.343v1.955a.343.343,0,0,1-.343.343",
  transform: "translate(6.224 -2)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2446",
  "data-name": "Path 2446",
  d: "M30.06,10.545c0-3.326,1.8-7.242-8.13-8.943A25.12,25.12,0,0,0,5.291,4.154c-3.309,1.7-1.756,6.3-1.756,6.3l12.734,1.565Z",
  transform: "translate(6.224 -2)",
  fill: "#00f288"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2447",
  "data-name": "Path 2447",
  d: "M17.251,1.2a27.626,27.626,0,0,1,4.679.4c9.927,1.7,8.13,5.617,8.13,8.943L16.269,12.018,3.535,10.452s-1.552-4.6,1.757-6.3A24,24,0,0,1,17.251,1.2m0-1.2A25.228,25.228,0,0,0,4.7,3.111C1.4,4.844,1.75,8.917,2.4,10.836a1.2,1.2,0,0,0,.991.807l12.734,1.566a1.2,1.2,0,0,0,.146.009c.043,0,.086,0,.128-.007l13.791-1.473a1.2,1.2,0,0,0,1.072-1.193c0-.4.029-.813.06-1.255.212-3.043.5-7.21-9.187-8.871A28.99,28.99,0,0,0,17.251,0",
  transform: "translate(6.224 -2)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2448",
  "data-name": "Path 2448",
  d: "M17.739,13.324a79.583,79.583,0,0,0-8.658.472,27.887,27.887,0,0,1-7.051.235,1.592,1.592,0,0,1-1.218-.955c-1.774-4.154,8.1-3.155,8.1-3.155a69.275,69.275,0,0,0,15.719-.052s9.878-1,8.1,3.156a1.591,1.591,0,0,1-1.218.954s-5.518.034-13.782-.655",
  transform: "translate(6.224 -2)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2449",
  "data-name": "Path 2449",
  d: "M4.065,14.756a14.236,14.236,0,0,1-2.126-.132A2.182,2.182,0,0,1,.26,13.313,2.312,2.312,0,0,1,.406,10.9C2.032,8.691,8.27,9.252,8.976,9.325a69.48,69.48,0,0,0,15.59-.051c.716-.073,6.952-.633,8.579,1.578a2.314,2.314,0,0,1,.146,2.41,2.178,2.178,0,0,1-1.68,1.311c-.142.008-5.727.031-13.922-.65a79.831,79.831,0,0,0-8.547.471,42.739,42.739,0,0,1-5.077.362M6.59,10.41c-2.166,0-4.547.293-5.217,1.2-.145.2-.3.538-.009,1.227a.985.985,0,0,0,.756.6A27.263,27.263,0,0,0,9.009,13.2a77.774,77.774,0,0,1,8.78-.475c8.135.678,13.667.651,13.729.654a.991.991,0,0,0,.669-.591c.294-.689.136-1.029-.009-1.227-.922-1.254-5.079-1.339-7.483-1.1a70.682,70.682,0,0,1-15.861.049c-.65-.065-1.432-.106-2.244-.106",
  transform: "translate(6.224 -2)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2450",
  "data-name": "Path 2450",
  d: "M15.261,9.192a.3.3,0,0,1-.175-.052.153.153,0,0,1-.072-.126V5.6a.153.153,0,0,1,.072-.126.288.288,0,0,1,.175-.052h1.584a4.964,4.964,0,0,1,.819.062,2.539,2.539,0,0,1,.662.2,1.1,1.1,0,0,1,.46.383,1.094,1.094,0,0,1,0,1.159,1.229,1.229,0,0,1-.456.405,2.455,2.455,0,0,1-.655.23,3.872,3.872,0,0,1-.792.076H16.3c-.023,0-.034.009-.034.025V9.014a.155.155,0,0,1-.069.126.276.276,0,0,1-.171.052ZM16.269,7.2c0,.017.011.025.034.025h.515q.9,0,.9-.578a.4.4,0,0,0-.233-.393,1.645,1.645,0,0,0-.707-.116H16.3c-.023,0-.034.006-.034.019Z",
  transform: "translate(6.224 -2)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2451",
  "data-name": "Path 2451",
  d: "M16.846,5.426a4.96,4.96,0,0,1,.818.062,2.516,2.516,0,0,1,.662.2,1.1,1.1,0,0,1,.461.383,1.092,1.092,0,0,1-.005,1.159,1.229,1.229,0,0,1-.456.405,2.43,2.43,0,0,1-.655.23,3.872,3.872,0,0,1-.792.076H16.3c-.022,0-.033.008-.033.025V9.014a.155.155,0,0,1-.069.126.278.278,0,0,1-.171.051h-.768a.294.294,0,0,1-.175-.051.153.153,0,0,1-.072-.126V5.6a.15.15,0,0,1,.072-.126.288.288,0,0,1,.175-.052ZM16.3,7.23h.516q.9,0,.9-.579a.4.4,0,0,0-.233-.392,1.64,1.64,0,0,0-.706-.116H16.3c-.022,0-.033.006-.033.019V7.2c0,.016.011.025.033.025m.543-3H15.262a1.484,1.484,0,0,0-.877.279,1.342,1.342,0,0,0-.57,1.1v3.41a1.345,1.345,0,0,0,.57,1.1,1.49,1.49,0,0,0,.877.278h.768a1.473,1.473,0,0,0,.9-.3,1.355,1.355,0,0,0,.54-.986,4.564,4.564,0,0,0,.451-.071,3.7,3.7,0,0,0,.974-.345,2.41,2.41,0,0,0,.89-.8,2.292,2.292,0,0,0,0-2.494,2.284,2.284,0,0,0-.944-.8,3.736,3.736,0,0,0-.972-.3,6.2,6.2,0,0,0-1.019-.078",
  transform: "translate(6.224 -2)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2452",
  "data-name": "Path 2452",
  d: "M16.983,24.347c-1.819,0-3.19-.86-3.19-2s1.371-2,3.19-2,3.189.859,3.189,2-1.372,2-3.189,2m0-2.8c-1.235,0-1.99.518-1.99.8s.755.8,1.99.8,1.989-.519,1.989-.8-.756-.8-1.989-.8",
  transform: "translate(6.224 -2)",
  fill: "#414143"
}));

function SvgPinClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinClose);
export default __webpack_public_path__ + "static/media/pin-close.10d0b5d3.svg";
export { ForwardRef as ReactComponent };